import { render } from "./PageTitle.vue?vue&type=template&id=443f9375&ts=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Common/PageTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "443f9375"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('443f9375', __exports__)) {
    api.reload('443f9375', __exports__)
  }
  
  module.hot.accept("./PageTitle.vue?vue&type=template&id=443f9375&ts=true", () => {
    api.rerender('443f9375', render)
  })

}


export default __exports__